import React from 'react';
import { SubComponentProps } from '../AccountRoot';
import statusMap from '../util/order-status'
//import toMoney from './tomoney';
//import { OrderDataInterface } from '../types/order';
import toDisplayTimestamp from '../util/display-timestamp';
import { makeOrderData, OrderData } from '../classes/order-db';
import OrderReview from '../order_form/OrderReview';
import toMoney from '../util/tomoney';


export interface OrderLogData {
  action: string;
  status?: number;
  comment?: string;
}

export interface OrderLog {
  id: number;
  order_id: number;
  user_id: number | null | undefined;
  admin_id: number | null | undefined;
  created: number;
  data: OrderLogData;
  admin_description: string | null | undefined;
  user_company: string | null | undefined;
  user_contact: string | null | undefined;
}


export interface Order {
  id: number;
  user_id: number;
  status: number;
  created: number;
  data: OrderData;
  ident: string;
  total: number;
  order_logs: OrderLog[];
}



export interface OrderRootProps extends SubComponentProps {
  ident: string;
  sec_key: string;
}

export interface OrderRootState {
  order: Order | undefined;
}


class OrderRoot extends React.Component<OrderRootProps, OrderRootState> {

  state: OrderRootState;


  constructor(props:OrderRootProps) {
    super(props);

    this.state = {
      order: undefined,
    };

  }


  componentDidUpdate(prevProps: OrderRootProps) {
    if (!prevProps.active && this.props.active) {
      this.fetchOrder(this.props.ident, this.props.sec_key);
    }
  }


  componentDidMount() {
    if (this.props.ident) {
      this.fetchOrder(this.props.ident, this.props.sec_key);
    }
  }


  render() {
    return (
      <div className="container">
        {(this.state.order && this.state.order.id) ? this.Order : ''}
      </div>
    );
  }


  get Order() {
    if (!this.state.order) return '';

    return (
      <div className="Order">

        <div className="alert alert-info margin-top2">
          <h4>
            Precious Pets would like to provide you with our condolences. 
            Precious Pets understands how difficult this time is and wants to assure you excellent service treating your loved one with the utmost dignity and respect. 
            If we are available for your request, you will have a confirmation email within one (1) hour. 
            If you have not received our confirmation email within one (1) hour we do suggest that you contact a twenty four hour emergency hospital.
          </h4>
          <h4>
          Thank you for choosing Precious Pets.
          </h4>
        </div>

        <h2 className="otitle">
          <span className="number">Order: {this.state.order.ident}</span>
          <span className="status">Status: {statusMap.get(this.state.order.status)}</span>
        </h2>
        <div className="row">
          <div className="col-md-6">
            {this.OrderTable}
          </div>
          <div className="col-md-6">
            {this.OrderLog}
          </div>
        </div>

      </div>
    )
  }


  get OrderTable() {
    if (!this.state.order) return '';

    const odata = this.state.order.data;
    const weight_vals = this.props.convertWeight(odata.info.weight);

    const acquire = odata.acquire;
    const release = odata.release;
    const payment = odata.payment;

    return (
    <table className="table-review">
      <tbody className="info">
        <tr className="heading">
          <th colSpan={3}>Pet/Owner Information</th>
        </tr>
        <tr>
          <td>Pet's Name</td>
          <td colSpan={2}>{odata.info.pet_name || 'N/A'}</td>
        </tr>
        <tr>
          <td>Species</td>
          <td colSpan={2}>{odata.info.pet_species || 'N/A'}</td>
        </tr>
        <tr>
          <td>Weight (lbs)</td>
          <td colSpan={2}>{weight_vals[0]}lbs {weight_vals[1]}oz</td>
        </tr>
        <tr>
          <td>Owner Name</td>
          <td colSpan={2}>{odata.info.owner_name || 'N/A'}</td>
        </tr>
        <tr>
          <td>Owner Phone</td>
          <td colSpan={2}>{odata.info.owner_phone || 'N/A'}</td>
        </tr>
        <tr>
          <td>Owner Email</td>
          <td colSpan={2}>{odata.info.owner_email || 'N/A'}</td>
        </tr>
      </tbody>

      <tbody className="order">
        <tr className="heading">
          <th colSpan={3}>Order</th>
        </tr>


        {this.pricedItemRow('Service', odata.service)}

        {this.pricedItemRow('Keepsake Urn', odata.urn, false, 
          odata.urn?.data?.engraving_type ? ' - '+odata.urn?.data?.engraving_type : '',
          odata?.urn?.data?.engraving_price || 0)}

        {this.pricedItemRow('Engraved Nameplate', odata.nameplate, true)}

        {(() => {
          if (odata.nameplate && odata.nameplate.data?.nameplate_lines) {
            return (
              <tr>
                <td>Engraving</td>
                <td>
                  {odata.nameplate.data?.nameplate_lines.map((l:any, i:any) => 
                    <div key={i}>{l}</div>
                  )}
                </td>
              </tr>
            );
          }
        })()}

        {this.pricedItemRow('Clay Pawprint', odata.pawprint, true, 
          odata.pawprint?.qty+"")}

        {this.pricedItemRow('Priority Service + Viewing Service Bundle', odata.viewing_and_priority_service, true)}

        {this.pricedItemRow('Priority Service', odata.priority_service, true)}

        {this.pricedItemRow('Viewing Service', odata.viewing_service, true)}

        {this.pricedItemRow('After Hours Appt', odata.after_hours_appointment, true)}
        
        {(() => {
          if (odata.comments) {
            return (
            <tr>
              <td>Other/Request</td>
              <td colSpan={2}>{odata.comments}</td>
            </tr>
            )
          }
        })()}


        <tr>
          <td style={{verticalAlign: 'top'}}>Acquire Method</td>
          <td>
            
            <div><b>{acquire.type === 'home' ? 'Home Pickup' : acquire.type === 'dropoff' ? 'PPMS Office Drop-off' : 'Standard'}</b></div>

            {acquire.type === 'home' && acquire.detail && 'name' in acquire.detail ? (
            <React.Fragment>
              <address>
                <div>
                  {acquire.detail.name}
                </div>
                <div>
                  {acquire.detail.address1}
                </div>
                {acquire.detail.address2 ? (
                <div>
                  {acquire.detail.address2}
                </div>
                ) : ''}
                <div>
                  {acquire.detail.city}, {' '}
                  {acquire.detail.state} {' '}
                  {acquire.detail.zip}
                </div>
              </address>
              
              <div>
                <b>Phone:</b> {' '}
                {acquire.detail.phone}
              </div>
            </React.Fragment>
            ) : ''}

            {acquire.detail && (acquire.type === 'home' || acquire.type === 'dropoff') ? (
            <div>
              <b>requested time:</b> {' '}
              {acquire.detail.requested_time ? 
                  toDisplayTimestamp(new Date(acquire.detail.requested_time).getTime() / 1000) :
                  'N/A'}
            </div>
            ) : ''}

          </td>
        </tr>
        {acquire.type === 'home' && acquire.fee ?
        <tr>
          <td>Home Pick-up Fee</td>
          <td></td>
          <td>{toMoney(acquire.fee)}</td>
        </tr>
        : ''}
        {this.pricedItemRow('Acquire Fee', odata.acquire_fee, false)}


        <tr>
          <td style={{verticalAlign: 'top'}}>Release Method</td>
          <td>
            
            <div><b>{release.type === 'home' ? 'Home Delivery' : release.type === 'pickup' ? 'PPMS Office Pick-up' : 'Standard'}</b></div>

            {release.type === 'home' && release.detail && 'name' in release.detail ? (
            <React.Fragment>
              <address>
                <div>
                  {release.detail.name}
                </div>
                <div>
                  {release.detail.address1}
                </div>
                {release.detail.address2 ? (
                <div>
                  {release.detail.address2}
                </div>
                ) : ''}
                <div>
                  {release.detail.city}, {' '}
                  {release.detail.state} {' '}
                  {release.detail.zip}
                </div>
              </address>
              
              <div>
                <b>Phone:</b> {' '}
                {release.detail.phone}
              </div>
            </React.Fragment>
            ) : ''}

            {release.detail && (release.type === 'home' || release.type === 'pickup') ? (
            <div>
              <b>requested time:</b> {' '}
              {release.detail.requested_time ? 
                  toDisplayTimestamp(new Date(release.detail.requested_time).getTime() / 1000) :
                  'N/A'}
            </div>
            ) : ''}

          </td>
        </tr>
        {release.type === 'home' && release.fee ?
        <tr>
          <td>Home Delivery Fee</td>
          <td></td>
          <td>{toMoney(release.fee)}</td>
        </tr>
        : ''}
        {this.pricedItemRow('Release Fee', odata.release_fee, false)}

        <tr className="total">
          <td colSpan={2}>Total</td>
          <td>{toMoney(odata.total)}</td>
        </tr>

      </tbody>

      <tbody className="order">
        <tr className="heading">
          <th colSpan={3}>Payment</th>
        </tr>

        <tr>
          <td>Payment Type</td>
          <td colSpan={2}>{payment.type}</td>
        </tr>

        {payment.type_detail ? (
        <tr>
          <td>Payment Detail</td>
          <td colSpan={2}>{payment.type_detail}</td>
        </tr>
        ) : null}

        {payment.type_detail === 'cash' ? (
        <tr>
          <td>Payment Cash Amount</td>
          <td colSpan={2}>{payment.cash_amount}</td>
        </tr>
        ) : null}

        {payment.type_detail === 'check' ? (
        <tr>
          <td>Payment Check Number</td>
          <td colSpan={2}>{payment.check_number}</td>
        </tr>
        ) : null}

        <tr>
          <td>Payment Comment</td>
          <td colSpan={2}>{payment.payment_comment}</td>
        </tr>

      </tbody>

    </table>
    )
  }


  get OrderLog() {
    const order = this.state.order;
    if (!order || !order.order_logs) return '';
    
    return (
    <div className="OrderLog">
      <h3>Order Log</h3>

      {order.order_logs.map(l => 
      
        <div className="logentry" key={l.id}>

          <div className="tsaction">
            <span className="ts">{toDisplayTimestamp(l.created)}</span>
            <span className="action">{
              l.data.status === 1 && l.user_id ? 
                'Order Placed' : 
                l.data.status ? 
                  'Status Updated' : 
                  'Added Comment' 
              }</span>
          </div>

          {l.user_id ? 
            <React.Fragment>
            {l.user_company || l.user_contact ? 
              <div className="user">
              {l.user_company} - {l.user_contact}
            </div>
            : ''}
            </React.Fragment>
          : 
            <div className="admin">
              {l.admin_description}
            </div>
          }

          {(l.data.status) ? (
            <div className="status">
              <span>Changed to </span>
              <span className="s">{statusMap.get(l.data.status)}</span>
            </div>
          ) : ''}

        </div>
          
      )}

    </div>
    )
  }


  pricedItemRow(itemName: string, p:any | undefined, boolLabel?: boolean, ex?: string, addPrice?: number) {

    if (!p) return;

    let label = '';
    if (boolLabel) {
      if (ex) {
        label = 'qty: '+ex;
      } else {
        label = 'yes';
      }
    } else {
      label = p.label;
      if (ex) {
        label += " "+ex;
      }
    }

    let price = p.priceData.total;
    let price_additional = p.priceData.total_additional || 0;

    let total = 0;
    if (p.priceData.type === 'fixed_additional') {
      total = price;
      if (p.qty > 1) {
        total += (p.qty - 1) * price_additional;
      }
    } else {
      total = price * (p.qty || 1);
    }

    return (
      <tr>
        <td>{itemName}</td>
        <td>{label}</td>
        <td>{p.priceData.total ? toMoney(total + (addPrice || 0)) : '-' }</td>
      </tr>
    )

  }


  async fetchOrder(ident:string, sec_key: string) {

    if (!ident || !sec_key) return;

    this.props.setLoading(true);

    const ret = await this.props.callAPI('get', `/order/${ident}/${sec_key}`);

    if (ret && ret.order) {
      const order = ret.order || {};
      order.data = makeOrderData(order.data || {});
      this.setState({
        order: order,
      })
    } else {
      this.props.addSnack({
        type: 'danger',
        title: 'Error',
        text: 'Error fetching order '+ident,
      })
    }

    this.props.setLoading(false);
  }

}


export default OrderRoot;
